import { render } from "./BuyMethBuy.vue?vue&type=template&id=5512eead"
import script from "./BuyMethBuy.vue?vue&type=script&lang=js"
export * from "./BuyMethBuy.vue?vue&type=script&lang=js"

import "./BuyMethBuy.vue?vue&type=style&index=0&id=5512eead&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__